import type { CarriedFrom, StatsSource } from '../types';

const LABEL: Record<StatsSource, string> = {
  season: 'this season',
  manual: 'manual',
  carried: 'last season',
  none: 'no data',
};

const COLOR: Record<StatsSource, string> = {
  season: 'var(--good)',
  manual: 'var(--home)',
  carried: 'var(--warn)',
  none: 'var(--text-dim)',
};

/**
 * Says where a player's numbers came from. Every figure in the app is traceable
 * to one of four sources, and a carried-over or hand-entered figure must never
 * be mistaken for something measured this season.
 */
export function SourceBadge({
  source,
  carriedFrom,
  note,
}: {
  source: StatsSource;
  carriedFrom?: CarriedFrom | null;
  note?: string | null;
}) {
  const title =
    source === 'carried' && carriedFrom
      ? `Carried from ${carriedFrom.leagueName}` +
        (carriedFrom.region ? ` (${carriedFrom.region})` : '') +
        (carriedFrom.season ? ` — ${carriedFrom.season}` : '') +
        (carriedFrom.seasonStart ? `, from ${carriedFrom.seasonStart}` : '')
      : source === 'manual'
        ? (note ?? 'Hand-entered statistics')
        : source === 'season'
          ? 'Played and recorded in this season'
          : 'No games recorded anywhere';

  return (
    <span className="tag" style={{ borderColor: COLOR[source], color: COLOR[source] }} title={title}>
      {LABEL[source]}
    </span>
  );
}
